import './badge.scss';

type BadgeProps = {
  label?: string;
  className?: string;
  ariaHidden?: boolean;
};

const Badge = ({ label = 'NEW', className, ariaHidden }: BadgeProps) => {
  return (
    <span
      className={['status-badge', className].filter(Boolean).join(' ')}
      {...(ariaHidden ? { 'aria-hidden': true } : {})}
    >
      {label}
    </span>
  );
};

export default Badge;
